import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "sub_content"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1);

const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "房型设置", -1);

const _hoisted_7 = {
  class: "content"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, [/*#__PURE__*/_createTextVNode("房型设置"), /*#__PURE__*/_createElementVNode("b")], -1);

const _hoisted_9 = {
  class: "base_details_content_second"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "须知设置", -1);

const _hoisted_11 = {
  class: "base_details_content_second"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "赠送设置", -1);

const _hoisted_13 = {
  class: "content"
};
const _hoisted_14 = {
  class: "content"
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_screen_header"
}, null, -1);

const _hoisted_16 = {
  class: "dialog-footer"
};
const _hoisted_17 = {
  class: "base_screen_header"
};
const _hoisted_18 = {
  class: "dialog-footer"
};
import BackTitleView from "@com/BackTitleView.vue";
import UploadPicture from "@com/upload/UploadPicture.vue";
import { ref } from 'vue';
import useRoute from "@util/router";
import MapSelectAddress from "@com/MapSelectAddress.vue";
import RoomConfigure from "@com/hotel/RoomConfigure.vue";
import api from "@api/hotel";
import { $box, $msg } from "@/common/ui/msg";
import $ from "@util/base";
import { Search } from "@element-plus/icons-vue";
import DataCollectTable from "@/components/table/DataCollectTable.vue";
import { COLUMN_TYPE, OP_KEY, OPERATIONS, operationsHander } from "@/components/table/tableOperations";
import couponApi from "@/api/coupon";
import tagsApi from "@/api/memberGrade";
export default {
  __name: 'HotelDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var isApproval = false;
    var title = "酒店详情";
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "酒店详情";
        getData();
      },
      add: () => {
        title = "新增酒店";
      },
      modify: () => {
        title = "修改酒店";
        getData();
      },
      examine: () => {
        readOnly = true;
        isApproval = true;
        title = "酒店详情";
        getData();
      }
    });
    const activeName = ref("basic");

    function tabChange(active) {
      activeName.value = active;
    }

    const noticeTemplate = {
      title: null,
      intro: null
    };
    const noticeData = ref([]);
    const noticeDynamic = ref(null);
    const roomConfigureData = ref([]);
    const roomConfigure = ref(null);
    const facility = ref([]);
    const catering = ref([]);
    const labelOptions = ref([]);
    const starOptions = ref([]); // const baseOptions = ref([])

    const typeOptions = ref([]);
    getConfig();

    function getConfig() {
      api.facility(val => facility.value = val);
      api.catering(val => catering.value = val);
      api.star(val => starOptions.value = val); // api.base(val => baseOptions.value = val)

      api.category(val => typeOptions.value = val);
      api.label(val => {
        labelOptions.value = val;
      });
    }

    const basicFormRef = ref(null);
    const basicForm = ref({
      id: null,
      categoryCode: null,
      hotelName: null,
      // shopCode: null,
      star: null,
      address: null,
      lat: null,
      lng: null,
      picList: [],
      descList: [],
      facility: [],
      catering: [],
      tags: [],
      flowStatus: null,
      flowCode: null,
      payType: '',
      payTypeList: ['1021001', '1021002'],
      couponItemList: [],
      tagsItemList: []
    });
    const basicRules = {
      categoryCode: [{
        required: true,
        message: '请选择酒店分类',
        trigger: 'change'
      }],
      hotelName: [{
        required: true,
        message: '请输入酒店名称',
        trigger: 'blur'
      }],
      // shopCode: [{
      //     required: true,
      //     message: '请选择归属基地',
      //     trigger: 'change',
      // }],
      star: [{
        required: true,
        message: '请选择酒店星级',
        trigger: 'change'
      }],
      address: [{
        required: true,
        message: '请填入地址'
      }],
      payTypeList: [{
        required: true,
        message: '请选择支付方式',
        trigger: 'change'
      }]
    };

    function selectAddress(data) {
      basicForm.value.lat = data.lat + "";
      basicForm.value.lng = data.lng + "";
      basicForm.value.address = data.address;
    }

    function back() {
      route.go(-1);
    }

    function getNoticeDynamic() {
      let data = noticeDynamic.value.getValue();
      return data;
    }

    function save(isExamine) {
      basicFormRef.value.validate(valid => {
        if (valid) {
          let roomData = roomConfigure.value.getValue();
          let noticeData = getNoticeDynamic();
          let baseicData = $.deepCopy(basicForm.value);

          if ($.isNotEmpty(baseicData.couponItemList)) {
            baseicData.couponItemList = baseicData.couponItemList.map((e, index) => {
              e.sort = e.sort || index + 1;
              return e;
            });
          }

          if ($.isNotEmpty(baseicData.tagsItemList)) {
            baseicData.tagsItemList = baseicData.tagsItemList.map((e, index) => {
              e.sort = e.sort || index + 1;
              return e;
            });
          }

          if ($.isNull(baseicData.lat) || $.isNull(baseicData.lng)) {
            $msg.error("请在地图中选择酒店地址");
            return;
          }

          if ($.isNotEmpty(baseicData.facility)) {
            baseicData.facility = baseicData.facility.join(",");
          } else {
            baseicData.facility = null;
          }

          if ($.isNotEmpty(baseicData.catering)) {
            baseicData.catering = baseicData.catering.join(",");
          } else {
            baseicData.catering = null;
          }

          if (baseicData.payTypeList.length > 0) {
            baseicData.payType = baseicData.payTypeList.join(",");
          }

          if (roomData != false // && noticeData != false
          ) {
            let paramsData = {
              isPass: isExamine ? 2 : 1,
              // 是否提交审核 1 不提交 2提交审核
              hotelItem: baseicData,
              roomSetUp: {
                hotelRoomItems: roomData,
                hotelTipItems: noticeData
              }
            };
            $.handleCRU(urlQuery.type, {
              add: () => {
                api.add(paramsData, () => {
                  $msg.succ("保存成功");
                  route.go(-1);
                });
              },
              modify: () => {
                paramsData.roomSetUp.hotelRoomItems = roomItemDelHander(roomData);
                api.update(paramsData, () => {
                  $msg.succ("保存成功");
                  route.go(-1);
                });
              }
            });
          }
        } else {
          $msg.error("请完善基本信息");
        }
      });
    } // 被删除的房型数据还在只是设置flag为0


    function roomItemDelHander(roomData) {
      if (oldHotelRoomItems) {
        for (const item of oldHotelRoomItems) {
          if (roomData.find(e => {
            return e.id === item.id;
          }) == null) {
            roomData.push({
              id: item.id,
              flag: 0
            });
          }
        }
      }

      console.log(roomData);
      return roomData;
    }

    var oldHotelRoomItems = null;

    function getData() {
      api.details(route.query().code, val => {
        let hotelItem = val.hotelItem;

        if (hotelItem.payType) {
          hotelItem.payTypeList = hotelItem.payType.split(",");
        } else {
          hotelItem.payTypeList = [];
        }

        if ($.isNotEmpty(hotelItem.facility)) {
          hotelItem.facility = hotelItem.facility.split(",").map(e => {
            return parseInt(e);
          });
        } else {
          hotelItem.facility = [];
        }

        if ($.isNotEmpty(hotelItem.catering)) {
          hotelItem.catering = hotelItem.catering.split(",").map(e => {
            return parseInt(e);
          });
        } else {
          hotelItem.catering = [];
        }

        hotelItem.tags = parseInt(hotelItem.tags);
        basicForm.value = hotelItem;
        roomConfigureData.value = val.roomSetUp.hotelRoomItems;
        noticeData.value = val.roomSetUp.hotelTipItems;
        oldHotelRoomItems = val.roomSetUp.hotelRoomItems;
      });
    } // 审批通过


    function approvalPass() {
      $box.open("通过", "确认该商品审批通过", () => {
        api.approval(basicForm.value.flowCode, '1007004', '', () => {
          $msg.succ("审批成功");
          route.go(-1);
        });
      });
    } // 驳回


    function approvalRefusal() {
      $box.input("确认驳回", "驳回原因", null, val => {
        api.approval(basicForm.value.flowCode, '1007003', val, () => {
          $msg.succ("驳回成功");
          route.go(-1);
        });
      });
    }

    const addCouponDialog = ref(false);
    const couponName = ref("");
    const couponDataTableRef = ref(null);
    const couponData = ref([]);
    const couponDataConfig = ref({
      showIndex: true,
      showSelection: true,
      column: [{
        label: "名称",
        prop: "name",
        width: 200
      }, {
        label: "已发放",
        prop: "provideNum",
        width: 100
      }, {
        label: "已核销",
        prop: "usedNum",
        width: 100
      }, {
        label: "当前状态",
        prop: "enableStatusName",
        width: 100
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }]
    });
    const couponDataSize = ref(10);
    const couponDataPage = ref(1);
    const couponDataTotal = ref(0);
    const couponDataHandler = operationsHander();
    const couponItemListHandler = operationsHander();
    const couponItemListConfig = ref({
      showIndex: true,
      operations: {
        label: '操作',
        width: 200,
        operations: getOperations
      },
      column: [{
        label: "数量",
        prop: "num",
        type: COLUMN_TYPE.input,
        operationsKey: OPERATIONS.input,
        width: 100
      }, {
        label: "名称",
        prop: "couponName",
        width: 200
      }, {
        label: "已发放",
        prop: "provideNum",
        width: 100
      }, {
        label: "已核销",
        prop: "usedNum",
        width: 100
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }]
    });
    const addTagsDialog = ref(false);
    const tagsDataTableRef = ref(null);
    const tagsData = ref([]);
    const tagsDataHandler = operationsHander();
    const tagsDataConfig = ref({
      showIndex: true,
      showSelection: true,
      column: [{
        label: "名称",
        prop: "name"
      }, {
        label: "权益",
        prop: "mrpInstall"
      }]
    });
    const tagsItemListHandler = operationsHander();
    const tagsItemListConfig = ref({
      showIndex: true,
      operations: {
        label: '操作',
        width: 200,
        operations: getOperations2
      },
      column: [{
        label: "编码",
        prop: "tagsCode"
      }, {
        label: "名称",
        prop: "name"
      }, {
        label: "有效期(天)",
        prop: "num",
        type: COLUMN_TYPE.input,
        operationsKey: OPERATIONS.input
      }]
    });

    function getOperations(data) {
      return [OPERATIONS.del];
    }

    function getOperations2(data) {
      return [OPERATIONS.del2];
    }

    couponItemListHandler.install(OP_KEY.delete, (data, row) => {
      $box.open("移除", "确认移除优惠券：" + data.couponName, () => {
        let index = basicForm.value.couponItemList.findIndex(e => {
          return e.couponCode === data.couponCode;
        });
        basicForm.value.couponItemList.splice(index, 1);
      });
    });
    tagsItemListHandler.install(OP_KEY.delete2, (data, row) => {
      $box.open("移除", "确认移除标签：" + data.name, () => {
        let index = basicForm.value.tagsItemList.findIndex(e => {
          return e.code === data.code;
        });
        basicForm.value.tagsItemList.splice(index, 1);
      });
    });

    function showAddCouponDialog() {
      getCouponData();
      addCouponDialog.value = true;
    }

    function showAddTagsDialog() {
      getTagsData();
      addTagsDialog.value = true;
    }

    function getTagsData() {
      tagsApi.list({// name: couponName.value,
      }, val => {
        tagsData.value = val.itemList;
      });
    }

    function getCouponData() {
      couponApi.list({
        name: couponName.value,
        page: couponDataPage.value,
        size: couponDataSize.value
      }, val => {
        couponData.value = val.list;
        couponDataTotal.value = val.total;
      });
    }

    function couponDataPageChange(type, val) {
      if (type == 'page') {
        couponDataPage.value = val;
      } else if (type == 'size') {
        couponDataSize.value = val;
      }

      getCouponData();
    }

    function couponDataSelectedSubmit() {
      let selected = couponDataTableRef.value.getSelectData();

      if ($.isEmpty(selected)) {
        $msg.error("请选择优惠券");
        return;
      } else {
        selected = selected.filter(f => {
          return !basicForm.value.couponItemList.some(s => {
            return s.couponCode === f.couponCode;
          });
        }).map(e => {
          return {
            couponCode: e.couponCode,
            couponName: e.name,
            provideNum: e.provideNum,
            usedNum: e.usedNum,
            lifespan: e.lifespan,
            couponDesc: e.couponDesc,
            createTime: e.createTime,
            creator: e.creator,
            sort: e.sort,
            num: 1
          };
        });
        basicForm.value.couponItemList = basicForm.value.couponItemList.concat(selected);
        addCouponDialog.value = false;
      }
    }

    function tagsDataSelectedSubmit() {
      let selected = tagsDataTableRef.value.getSelectData();

      if ($.isEmpty(selected)) {
        $msg.error("请选择标签");
        return;
      } else {
        selected = selected.filter(f => {
          return !basicForm.value.tagsItemList.some(s => {
            return s.tagsCode === f.code;
          });
        }).map(e => {
          return {
            tagsCode: e.code,
            name: e.name,
            sort: e.sort,
            num: 1
          };
        });
        basicForm.value.tagsItemList = basicForm.value.tagsItemList.concat(selected);
        addTagsDialog.value = false;
      }
    }

    return (_ctx, _cache) => {
      const _component_el_badge = _resolveComponent("el-badge");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_DynamicParams = _resolveComponent("DynamicParams");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => activeName.value = $event),
            type: "border-card",
            class: "base_details_tabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              name: "basic"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
                ref_key: "basicFormRef",
                ref: basicFormRef,
                model: basicForm.value,
                rules: basicRules,
                "label-width": "100px",
                class: "base_details_form",
                disabled: _unref(readOnly)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "酒店分类",
                  prop: "categoryCode"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.value.categoryCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => basicForm.value.categoryCode = $event),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "酒店名称",
                  prop: "hotelName"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.hotelName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => basicForm.value.hotelName = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "酒店评级",
                  prop: "star"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.value.star,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => basicForm.value.star = $event),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(starOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "酒店地址",
                  prop: "address"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.address,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => basicForm.value.address = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"]), _createVNode(MapSelectAddress, {
                    class: "selectMap",
                    position: [basicForm.value.lng, basicForm.value.lat],
                    onSelect: selectAddress,
                    disabled: _unref(readOnly)
                  }, null, 8, ["position", "disabled"])])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "酒店封面",
                  prop: "picList"
                }, {
                  default: _withCtx(() => [_createVNode(UploadPicture, {
                    modelValue: basicForm.value.picList,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => basicForm.value.picList = $event),
                    limit: 10,
                    imgSize: _unref($).describeImgSize(),
                    fileSize: _unref($).imgFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "imgSize", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "酒店简介",
                  prop: "descList"
                }, {
                  default: _withCtx(() => [_createVNode(UploadPicture, {
                    modelValue: basicForm.value.descList,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => basicForm.value.descList = $event),
                    limit: 50,
                    fileSize: _unref($).imgFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "酒店设施",
                  prop: "facility"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                    modelValue: basicForm.value.facility,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => basicForm.value.facility = $event)
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facility.value, item => {
                      return _openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.id,
                        label: item.id
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "餐饮服务",
                  prop: "catering"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                    modelValue: basicForm.value.catering,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => basicForm.value.catering = $event)
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(catering.value, item => {
                      return _openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.id,
                        label: item.id
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "酒店标签"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.value.tags,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => basicForm.value.tags = $event),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labelOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "支付方式",
                  prop: "payTypeList"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                    modelValue: basicForm.value.payTypeList,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => basicForm.value.payTypeList = $event)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                      label: "1021001"
                    }, {
                      default: _withCtx(() => [_createTextVNode("微信支付")]),
                      _: 1
                    }), _createVNode(_component_el_checkbox, {
                      label: "1021002"
                    }, {
                      default: _withCtx(() => [_createTextVNode("储值卡支付")]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["model", "disabled"])])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: "spec"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_6]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(RoomConfigure, {
                ref_key: "roomConfigure",
                ref: roomConfigure,
                data: roomConfigureData.value,
                readOnly: _unref(readOnly)
              }, null, 8, ["data", "readOnly"])]), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_DynamicParams, {
                ref_key: "noticeDynamic",
                ref: noticeDynamic,
                template: noticeTemplate,
                showDefault: false,
                data: noticeData.value,
                operation: _unref($).DPMoveOperation(_unref(readOnly)),
                addText: "添加须知"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  label: "须知内容",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createVNode(_component_el_input, {
                    class: "m_b_10",
                    modelValue: scope.row.title,
                    "onUpdate:modelValue": $event => scope.row.title = $event,
                    placeholder: "请输入须知标题",
                    clearable: "",
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _createVNode(_component_el_input, {
                    modelValue: scope.row.intro,
                    "onUpdate:modelValue": $event => scope.row.intro = $event,
                    rows: 3,
                    type: "textarea",
                    placeholder: "请输入须知内容",
                    clearable: "",
                    resize: "none",
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data", "operation"])])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: "coupon"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_12]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
                onClick: showAddCouponDialog,
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("添加优惠券")]),
                _: 1
              }), _createVNode(DataCollectTable, {
                ref: "couponItemListTableRef",
                data: basicForm.value.couponItemList,
                config: couponItemListConfig.value,
                isRoute: false,
                onOperationsHander: _unref(couponItemListHandler).receive,
                isPage: false
              }, null, 8, ["data", "config", "onOperationsHander"])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
                onClick: showAddTagsDialog,
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("添加会员等级")]),
                _: 1
              }), _createVNode(DataCollectTable, {
                ref: "tagsItemListTableRef",
                data: basicForm.value.tagsItemList,
                config: tagsItemListConfig.value,
                isRoute: false,
                onOperationsHander: _unref(tagsItemListHandler).receive,
                isPage: false
              }, null, 8, ["data", "config", "onOperationsHander"])])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
            title: "添加会员等级",
            modelValue: addTagsDialog.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => addTagsDialog.value = $event),
            width: "80%",
            "destroy-on-close": ""
          }, {
            footer: _withCtx(() => [_createElementVNode("span", _hoisted_16, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: tagsDataSelectedSubmit
            }, {
              default: _withCtx(() => [_createTextVNode("保存")]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[11] || (_cache[11] = $event => addTagsDialog.value = false)
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            })])]),
            default: _withCtx(() => [_hoisted_15, _createVNode(DataCollectTable, {
              ref_key: "tagsDataTableRef",
              ref: tagsDataTableRef,
              data: tagsData.value,
              config: tagsDataConfig.value,
              isRoute: false,
              onOperationsHander: _unref(tagsDataHandler).receive,
              isPage: false
            }, null, 8, ["data", "config", "onOperationsHander"])]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
            title: "添加优惠券",
            modelValue: addCouponDialog.value,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => addCouponDialog.value = $event),
            width: "80%",
            "destroy-on-close": ""
          }, {
            footer: _withCtx(() => [_createElementVNode("span", _hoisted_18, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: couponDataSelectedSubmit
            }, {
              default: _withCtx(() => [_createTextVNode("保存")]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[15] || (_cache[15] = $event => addCouponDialog.value = false)
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_form, {
              inline: true,
              class: "base_search_form",
              onSubmit: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: couponName.value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => couponName.value = $event),
                  "onKeyup[native]": getCouponData,
                  onChange: getCouponData,
                  placeholder: "优惠券名称",
                  clearable: "",
                  "suffix-icon": _unref(Search)
                }, null, 8, ["modelValue", "suffix-icon"])]),
                _: 1
              })]),
              _: 1
            })]), _createVNode(DataCollectTable, {
              ref_key: "couponDataTableRef",
              ref: couponDataTableRef,
              data: couponData.value,
              config: couponDataConfig.value,
              isRoute: false,
              onOperationsHander: _unref(couponDataHandler).receive,
              total: couponDataTotal.value,
              onPageChange: couponDataPageChange
            }, null, 8, ["data", "config", "onOperationsHander", "total"])]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'basic']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[18] || (_cache[18] = $event => tabChange('spec')),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("下一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'basic']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[19] || (_cache[19] = $event => tabChange('basic'))
          }, {
            default: _withCtx(() => [_createTextVNode("上一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'spec']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[20] || (_cache[20] = $event => tabChange('spec'))
          }, {
            default: _withCtx(() => [_createTextVNode("上一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'coupon']]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[21] || (_cache[21] = $event => tabChange('coupon')),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("下一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value === 'spec']]), !_unref(readOnly) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[22] || (_cache[22] = $event => save(false)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'coupon']]) : _createCommentVNode("", true), !_unref(readOnly) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: _cache[23] || (_cache[23] = $event => save(true)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存并提交审核 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'coupon']]) : _createCommentVNode("", true), _unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: approvalPass,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批通过 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'coupon' && basicForm.value.flowStatus == '1007002']]) : _createCommentVNode("", true), _unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            onClick: approvalRefusal,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批驳回 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 'coupon' && basicForm.value.flowStatus == '1007002']]) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};